import React from "react";
import { Plus } from "lucide-react";

import type { WikiSuggestion } from "util/constants";

interface Props {
  suggestion: WikiSuggestion;
  onSelect: (suggestion: WikiSuggestion) => void;
}

const SearchIssueSuggestionItem: React.FC<Props> = ({
  suggestion,
  onSelect,
}) => {
  return (
    <li
      className="group px-2 py-2 hover:bg-eoe-icon dark:hover:bg-eoe-dark-icon cursor-pointer text-eoe-text dark:text-eoe-dark-text flex justify-between items-center"
      onClick={() => onSelect(suggestion)}
    >
      <div className="flex items-center gap-1.5 px-1.5 py-1">
        <span className="w-8 h-8 flex-shrink-0">
          <img
            src={
              suggestion.thumbnail && suggestion.thumbnail.trim() !== ""
                ? suggestion.thumbnail
                : "https://upload.wikimedia.org/wikipedia/en/8/80/Wikipedia-logo-v2.svg"
            }
            alt="Issue avatar"
            className="w-full h-full rounded-full object-cover"
          />
        </span>
        <div className="flex flex-col min-w-0">
          <span className="leading-tight line-clamp-1 text-sm italic">
            {suggestion.name}
          </span>
          <span className="leading-tight line-clamp-1 text-xs italic">
            {suggestion.short_description || ""}
          </span>
        </div>
      </div>
      <div className="flex items-center space-x-0 rounded-full group-hover:bg-eoe-icon-hover dark:group-hover:bg-eoe-dark-icon-hover text-eoe-gray dark:text-eoe-dark-text flex-shrink-0">
        <img
          src="https://upload.wikimedia.org/wikipedia/en/8/80/Wikipedia-logo-v2.svg"
          alt="Wikipedia Logo"
          className="w-5 h-5 rounded-full text-eoe-gray dark:text-eoe-dark-text flex-shrink-0"
        />
        <Plus className="w-5 h-5 rounded-full text-eoe-gray dark:text-eoe-dark-text flex-shrink-0" />
      </div>
    </li>
  );
};

export default SearchIssueSuggestionItem;
